import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ThumbType } from '~/shared/api'
import { Button } from '~/shared/ui/Buttons'
import { ImageSlider } from '~/shared/ui/ImageSlider'
import { IonToolbarFooter, IonToolbarHeader } from '~/shared/ui/PageContainer'
import { EmptyMessage, Title, WrapperFooter, WrapperHeader } from './styled'

type ImageSliderModalProps = {
  photos?: ThumbType[]
  isShow: boolean
  onCancel: () => void
  title: string
  empty?: string
}

export function ImageSliderModal({
  photos,
  isShow,
  onCancel,
  title,
  empty,
}: ImageSliderModalProps) {
  const { t } = useTranslation()

  const images = useMemo(() => {
    return (photos || []).map((photo) => ({
      id: photo.uuid,
      src: photo.originalUrlDownload,
    }))
  }, [photos])

  return (
    <IonModal
      isOpen={isShow}
      keepContentsMounted={false}
      onWillDismiss={onCancel}
    >
      <IonHeader>
        <IonToolbarHeader>
          <WrapperHeader>
            <Title data-testid='image-slider-title'>{title}</Title>
          </WrapperHeader>
        </IonToolbarHeader>
      </IonHeader>
      <IonContent
        style={{
          '--overscroll-behavior': 'none',
          '--webkit-overscroll-behavior': 'none',
          '--overflow': 'hidden',
        }}
      >
        {photos?.length ? (
          <ImageSlider images={images} />
        ) : (
          <EmptyMessage>{empty || t('alert.images not found')}</EmptyMessage>
        )}
      </IonContent>
      <IonFooter>
        <IonToolbarFooter>
          <WrapperFooter>
            <Button variant='textBlue' onClick={onCancel}>
              {t('button.close')}
            </Button>
          </WrapperFooter>
        </IonToolbarFooter>
      </IonFooter>
    </IonModal>
  )
}
